<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Profil
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Imię</label>
              <md-input v-model="userData.name" type="text" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Nazwisko</label>
              <md-input v-model="userData.surname" type="text" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Email</label>
              <md-input v-model="userData.email" type="email" />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Telefon</label>
              <md-input
                v-mask="'###-###-###'"
                v-model="userData.phone"
                type="text"
              />
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Link referencyjny</label>
              <md-input ref="refLink" v-model="userData.link" type="text" />
              <a href.prevent="#" class="copy-btn" @click="copyLink">
                <md-icon>file_copy</md-icon>
              </a>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50 d-flex-align">
            <div>Dane w raporcie</div>
            <md-switch v-model="userData.isAnon" />
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50 d-flex-align">
            <div>Email powiadomienia</div>
            <md-switch v-model="userData.isNotifications" />
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button @click="show = true" class="md-raised mt-4"
              >Zmiana hasła
            </md-button>
            <md-button @click="updateProfile" class="md-raised md-info mt-4"
              >Zaktualizuj profil
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <Modal v-if="show">
      <template slot="header">
        <h4 class="modal-title">Zmiana hasła</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="show = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <form>
          <md-field>
            <label>Stare hasło</label>
            <md-input type="password" v-model="oldPass" />
          </md-field>
          <md-field>
            <label>Nowe hasło</label>
            <md-input type="password" v-model="newPass" />
          </md-field>
        </form>
      </template>
      <template slot="footer">
        <md-button class="md-info" @click="changePass()">
          Zapisz
        </md-button>
      </template>
    </Modal>
  </form>
</template>
<script>
import { mapGetters } from 'vuex'
import Modal from '../../../components/Modal'

export default {
  name: 'edit-profile-form',
  components: {
    Modal,
  },
  props: {
    headerColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      oldPass: '',
      newPass: '',
      cachedEmail: this.$store.state.user.userData.email,
    }
  },
  methods: {
    getClass(headerColor) {
      return 'md-card-header-' + headerColor + ''
    },
    changePass() {
      this.$store
        .dispatch('changePassword', {
          oldPass: this.oldPass,
          newPass: this.newPass,
        })
        .then(() => {
          this.$message('Hasło zostało zmienione')
          this.oldPass = ''
          this.newPass = ''
          this.show = false
        })
        .catch(error => this.$error(error.response.data))
    },
    updateProfile() {
      this.$store
        .dispatch('updateUserData', {
          email: this.userData.email,
          phone: this.userData.phone,
          name: this.userData.name.trim(),
          surname: this.userData.surname.trim(),
          isAnon: this.userData.isAnon,
          isNotifications: this.userData.isNotifications,
        })
        .then(() => {
          if (this.userData.email !== this.cachedEmail) {
            this.$message(
              `Email został wysłany na skrzynkę ${this.cachedEmail}`
            )
            this.cachedEmail = this.userData.email
          } else {
            this.$message('Profil został zaktualizowany')
          }
        })
        .catch(error => this.$error(error.response.data))
    },

    copyLink() {
      const text = this.$refs.refLink.$el
      text.select()
      text.setSelectionRange(0, 99999) /*For mobile devices*/
      /* Copy the text inside the text field */
      document.execCommand('copy')
      this.$message('Skopiowano do schowka')
    },
  },
  computed: {
    ...mapGetters(['userData']),
  },
}
</script>
<style>
.copy-btn {
  cursor: pointer;
}

.d-flex-align {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
